<script setup>
import { computed, ref } from 'vue'
import ImageMin from '@/images/ImageMin.vue'

import Image_app_test from '@/assets/app_test.webp';

const props = defineProps({
   title: String,
   description: String,
   text_additional: String,
   firstColor: {
      type: String,
      default: null
   },
   secondaryColor: {
      type: String,
      default: null
   }
})

const imgUrl = window.appImageMain
function getImgUrl() {
   return imgUrl || Image_app_test
}

let isVerifiedTitle = ref(false)
let isVerifiedDescription = ref(false)

if ('isVerifiedTitle' in window.messagesDict.ru.header) {
   isVerifiedTitle.value = window.messagesDict.ru.header.isVerifiedTitle
}

if ('isVerifiedDescription' in window.messagesDict.ru.header) {
   isVerifiedDescription.value = isVerifiedTitle.value ? false : window.messagesDict.ru.header.isVerifiedDescription
}

</script>

<template>

   <div :class="'block__content--conteiner RTL'"
      :style="firstColor ? `color: ${firstColor};` : ''">
      <div class="block__content--image">
         <ImageMin :imgUrl="getImgUrl()" />
      </div>
      
      <div :class="'block__content--right_block'">
         <h1 class="block__content--title">
            {{ props.title }}<span class="svgIsVerified svgIsVerified__title" v-if="isVerifiedTitle">
               <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_14022_20461)">
                     <path
                        d="M7.16548 0.603236L10.3065 2.00504L13.3421 0.387545L15.0592 3.36786L18.4658 3.84355L18.1032 7.264L20.5796 9.65117L18.2758 12.2053L18.8761 15.5921L15.511 16.3042L14.0059 19.3971L10.8649 17.9953L7.82931 19.6128L6.11214 16.6325L2.70558 16.1568L3.06814 12.7363L0.591774 10.3492L2.89559 7.79506L2.29531 4.40823L5.66039 3.69608L7.16548 0.603236Z"
                        fill="#21A2F5" />
                     <path d="M14.5859 8L9.80022 13L7.08594 10.5" stroke="white" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                     <clipPath id="clip0_14022_20461">
                        <rect x="0.585938" width="20" height="20" rx="4" fill="white" />
                     </clipPath>
                  </defs>
               </svg></span>
         </h1>
         <span class="block__content--description">
            {{ props.description }}<span class="svgIsVerified svgIsVerified__description" v-if="isVerifiedDescription">
               <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_14022_20461)">
                     <path
                        d="M7.16548 0.603236L10.3065 2.00504L13.3421 0.387545L15.0592 3.36786L18.4658 3.84355L18.1032 7.264L20.5796 9.65117L18.2758 12.2053L18.8761 15.5921L15.511 16.3042L14.0059 19.3971L10.8649 17.9953L7.82931 19.6128L6.11214 16.6325L2.70558 16.1568L3.06814 12.7363L0.591774 10.3492L2.89559 7.79506L2.29531 4.40823L5.66039 3.69608L7.16548 0.603236Z"
                        fill="#21A2F5" />
                     <path d="M14.5859 8L9.80022 13L7.08594 10.5" stroke="white" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                     <clipPath id="clip0_14022_20461">
                        <rect x="0.585938" width="20" height="20" rx="4" fill="white" />
                     </clipPath>
                  </defs>
               </svg></span>
         </span>

         <span class="block__content--text__additional"
            :style="props.secondaryColor ? `color: ${props.secondaryColor};` : ''">
            {{ props.text_additional }}
         </span>

      </div>

   </div>
</template>

<style lang="scss">
.block_ {

   &_content {
      padding: var(--app_common_padding);

      &--image {
         padding: 3px 24px;
         text-align: left;
      }

      &--conteiner {
         position: relative;
         z-index: 1;
         display: flex;
         flex-direction: row;
         align-items: center;
         justify-content: flex-start;
         align-content: center;
         overflow: hidden;
         // align-items: flex-start;
      }

      &--right_block {
         display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: flex-start;
      }

      // .block__content--title
      &--title {
         font-family: var(--app_common_fomt_family);
         line-height: 2rem;
         font-size: 1.5rem;
         letter-spacing: 0;
         font-weight: 400;
         font-weight: 500;
         // display: flex;
         // align-items: flex-end;
         overflow-wrap: anywhere;
         width: 100%;
         word-break: keep-all;

      }

      &--description {
         color: var(--app_marked_text_color);
         font-weight: 500;
         letter-spacing: .00625em;
         // color: #8ae027;
      }

      &--text__additional {
         font-family: var(--app_common_fomt_family);
         // font-family: Roboto, Arial, sans-serif;
         line-height: 1rem;
         font-size: .75rem;
         letter-spacing: .025em;
         font-weight: 400;
         align-items: center;
         display: flex;
         height: 20px;
         justify-content: center;
         white-space: nowrap;
      }

   }
}

.svgIsVerified {
   padding-left: 5px;
}

.svgIsVerified__title svg {
   transform: translateY(7%);
}

.svgIsVerified__description svg {
   transform: translateY(15%);
}
</style>
